export class Metadata
{
    constructor(json:any)
    {
    }
}
